import { regex } from "views/pages/manage/common/constant";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

  export const initialForm={
    sapPlantId:'',
    sapBusinessArea:'',
    sapDescription:'',
    businessPlaceCode:'',
    defermentBusinessArea:'',
    gstInNumber:''
  }
export const buUnitMapping={
  Franchise:"FRANCHISE",
  SubContractor:"SUB_CONTRACTOR",
  Owned:"OWNED"
}
export const getReqObj = (form) => {
  return {
    sapPlantId: form?.sapPlantId,
    sapBusinessArea: form?.sapBusinessArea,
    sapDescription: form?.sapDescription,
    businessPlaceCode: form?.businessPlaceCode,
    defermentBusinessArea: form?.defermentBusinessArea,
    gstInNumber: form?.gstInNumber,
    businessAreaId: form?.buId,
    businessAreaVendorDetailsDTO: form?.vendorDetails || {},
    businessUnitType: buUnitMapping?.[form?.businessUnitType] || form?.businessUnitType
  };
};

  export const statusMapping={
    SUCCESS: 'Success',
    NOTMAPPED: "Not Mapped",
    FAILED: "Failed"
  }
  const COMMON_STYLE={
    fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
  }

 export  const statusMappingStyle={
    SUCCESS:{
      ...COMMON_STYLE,
      color: '#05945B'
    },
    FAILED:{
       ...COMMON_STYLE,
       color:'#D29822'
    },
    NOTMAPPED:{
      ...COMMON_STYLE,
      color: '#757575'
    }
  }

export const getLatestUpdateInfo = (...entries) => {
  const isValidDate = (dateStr) => dateStr && !isNaN(Date.parse(dateStr));

  const validEntries = entries
    .filter(entry => isValidDate(entry?.updatedOn))
    .map(entry => ({
      ...entry,
      _date: new Date(entry.updatedOn)
    }));

  if (!validEntries.length) return null;

  return validEntries.reduce((latest, current) =>
    current._date > latest._date ? current : latest
  );
};

export const vendorDetail = [
  { colKey: 'supplierBillTo', label: 'Supplier (Bill To)*', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'vendor', label: 'Vendor*', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'vendorCode', label: 'Vendor Code* ', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'type', label: 'Type* ', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'acctAssignmentCtg', label: 'Acct. Assignmentctg.* ', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'itemCategory', label: 'Item Category*', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'qty', label: 'Qty*', colType: 'input', disabled: false, regex: regex.numeric, renderData: (val) => val },
  { colKey: 'uom', label: 'UOM*', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'invoiceTax', label: 'Invoice/Tax*', colType: 'input', disabled: false, renderData: (val) => val },
  // { colKey: 'gstInNumber', label: 'GSTIN Number* ', colType: 'input', disabled: false },

];

export const checkValidations = (form, isSubContractor, vendorGlobalForm) => {
  debugger
           if (form.sapPlantId && form.sapPlantId?.length < 4) {
              failureToast('Please Enter Valid SAP plant ID');
              return false;
          } else if (form.sapBusinessArea && form.sapBusinessArea?.length < 4) {
              failureToast('Please Enter Valid SAP Business Area');
              return false;
          } else if (form.businessPlaceCode && form.businessPlaceCode?.length < 4) {
              failureToast('Please Enter Valid Business place code');
              return
          } else if (form.defermentBusinessArea && form.defermentBusinessArea?.length < 4) {
              failureToast('Please Enter Valid Deferment business area');
              return false;
          }
          // else if (isSubContractor && (!vendorGlobalForm?.supplierBillTo || vendorGlobalForm?.supplierBillTo?.length <= 0)) {
          //     failureToast('Please Enter Valid Supplier (Bill To) details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.vendor)) {
          //     failureToast('Please Enter Valid Vendor Details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.vendorCode || vendorGlobalForm?.vendorCode?.length <= 0)) {
          //     failureToast('Please Enter Valid Vendor Code details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.type || vendorGlobalForm?.type?.length <= 0)) {
          //     failureToast('Please Enter Valid Type details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.acctAssignmentCtg || vendorGlobalForm?.acctAssignmentCtg?.length <= 0)) {
          //     failureToast('Please Enter Valid Account Assignment Category details as business unit type is SubContractor');
          //     return
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.itemCategory || vendorGlobalForm?.itemCategory?.length <= 0)) {
          //     failureToast('Please Enter Valid Item Category details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.qty || vendorGlobalForm?.qty <= 0)) {
          //     failureToast('Please Enter Valid Quantity details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.uom || vendorGlobalForm?.uom?.length <= 0)) {
          //     failureToast('Please Enter Valid UOM details as business unit type is SubContractor');
          //     return false;
          // }
          // else if (isSubContractor && (!vendorGlobalForm?.invoiceTax || vendorGlobalForm?.invoiceTax?.length <= 0)) {
          //     failureToast('Please Enter Valid Invoice/Tax details as business unit type is SubContractor');
          //     return false;
          // }
          else
            return true;
}

export const emptyVendorForm = {
  supplierBillTo: null,
  vendor: null,
  vendorCode: null,
  type: null,
  acctAssignmentCtg: null,
  itemCategory: null,
  qty: null,
  uom: null,
  invoiceTax: null
};